export enum EPageType {
  product = 'Product',
  purchase = 'Purchase',
  landingPage = 'LP',
  block = 'Block',
}

export interface PageViewEventPayload {
  eventName: string;
  screen?: string;
  pageType: EPageType;
  source?: string;
  extraProperties?: Record<string, unknown>;
}

/**
 * Structure of a single experiment entry in the Mixpanel cookie
 */
export interface IMixpanelCookieExperiment {
  readonly data: {
    readonly value: unknown;
    readonly variationId: number;
  };
  readonly sent: boolean;
}

/**
 * Structure of the experiments cookie from the extension
 */
export interface IMixpanelExperimentsCookie {
  readonly [experimentKey: string]: IMixpanelCookieExperiment;
}

export type BrazeAttributeValue =
  | string
  | number
  | boolean
  | Date
  | string[]
  | null;

export type BrazeAttributes = Readonly<Record<string, BrazeAttributeValue>>;
